import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { getMyBirthday } from "@/lib/api";
import { BirthdayField, birthdayText } from "@/components/StaffBirthday";

// My profile. /profile?birthday=1 opens straight to the birthday field (for emails: "tap here and add your birthday").
export default function Profile() {
  const { user } = useAuth();
  const loc = useLocation();
  const [bday, setBday] = useState(undefined);
  const fieldRef = useRef(null);
  const boxRef = useRef(null);
  const jump = new URLSearchParams(loc.search).get("birthday") === "1";

  useEffect(() => { getMyBirthday().then((d) => setBday(d.birthday)).catch(() => setBday(null)); }, []);
  useEffect(() => {
    if (!jump || bday === undefined) return;
    boxRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    fieldRef.current?.focus();
  }, [jump, bday]);

  return (
    <div className="space-y-6 max-w-2xl" data-testid="profile-page">
      <div>
        <div className="eyebrow">Your account</div>
        <h2 className="font-display text-3xl font-extrabold mt-1 tracking-tight">My profile</h2>
      </div>
      <section className="card-surface p-5 space-y-1">
        <div className="text-sm font-medium">{user?.name}</div>
        <div className="text-xs text-zinc-400">{user?.email}</div>
        {user?.employee_id && <div className="text-xs text-zinc-500 font-mono">Staff ID {user.employee_id}</div>}
      </section>
      <section ref={boxRef} id="birthday" className={`card-surface p-5 space-y-3 ${jump ? "ring-1 ring-rose-500/40" : ""}`} data-testid="profile-birthday">
        <div>
          <div className="text-sm font-medium">🎂 Birthday</div>
          <p className="text-xs text-zinc-400 mt-1">
            On the day, everyone at your gym sees it's your birthday. They only see the day and month; the year is
            optional and only your managers can see it.
          </p>
          {bday && <p className="text-xs text-zinc-300 mt-2" data-testid="profile-birthday-saved">Saved: {birthdayText(bday)}</p>}
        </div>
        {bday !== undefined && <BirthdayField ref={fieldRef} value={bday} onSaved={setBday} />}
      </section>
    </div>
  );
}
